import { Resolve } from 'vue-di';
import EnrollmentModule from '~/store/enrollment';
import styles from '~/assets/style/variables.scss';
import harvoniStyles from '~/assets/style/harvoniVariables.scss';
import genericHarvoniStyles from '~/assets/style/genericHarvoniVariables.scss';
import epclusaStyles from '~/assets/style/epclusaVariables.scss';
import genericEpclusaStyles from '~/assets/style/genericEpclusaVariables.scss';
import solvadiStyles from '~/assets/style/sovaldiVariables.scss';
import voseviStyles from '~/assets/style/voseviVariables.scss';
import { ProgramState } from '~/types/types';

export default class StyleService {
    styles = styles;
    harvoniStyles = harvoniStyles;
    genericHarvoniStyles = genericHarvoniStyles;
    epclusaStyles = epclusaStyles;
    genericEpclusaStyles = genericEpclusaStyles;
    sovaldiStyles = solvadiStyles;
    voseviStyles = voseviStyles;

    getProgramStyle(state: ProgramState) {
        switch (state || ProgramState.Gilead) {
            case ProgramState.Gilead: {
                return this.epclusaStyles;
            }
            case ProgramState.Harvoni: {
                return this.harvoniStyles;
            }
            case ProgramState.GenericHarvoni: {
                return this.genericHarvoniStyles;
            }
            case ProgramState.Epclusa: {
                return this.epclusaStyles;
            }
            case ProgramState.GenericEpclusa: {
                return this.genericEpclusaStyles;
            }
            case ProgramState.Sovaldi: {
                return this.sovaldiStyles;
            }
            case ProgramState.Vosevi: {
                return this.voseviStyles;
            }
            default: {
                return styles;
            }
        }
    }
}
